<div class="tile-container-scrollable">
  <div class="d-flex justify-content-between" *qmLoading="loading;config:loadingConfig">
    <div class="card">
      <div class="card-header">
        {{'Data from train GPS' | translate}}
      </div>
      <ul *ngIf="train?.positionChanged; else konegisElseBlock" class="list-group list-group-flush">
        <li class="list-group-item" [@animatedUpdate]="train.calculatedDelta">
          <h5>
            {{'Timetable deviation' | translate}}
          </h5>
          <p>
            {{train.calculatedDelta}} {{'minutes' | translate}}
          </p>
        </li>
        <li class="list-group-item">
          <h5>
            {{'Equipment units' | translate}}
          </h5>
          <p>
            {{train.equipment}}
          </p>
        </li>
        <li class="list-group-item" [@animatedUpdate]="train.station">
          <h5>
            {{'Previous station' | translate}}
          </h5>
          <p>
            {{train.station}}
          </p>
        </li>
        <li class="list-group-item" [@animatedUpdate]="train.velocity">
          <h5>
            {{'Speed' | translate}}
          </h5>
          <p>
            {{train.velocity}}
          </p>
        </li>
        <li class="list-group-item" [@animatedUpdate]="train.positionChanged">
          <h5>
            {{'Data updated' | translate}}
          </h5>
          <p>
            {{train.positionChanged | qmDateDistance}}
          </p>
        </li>
        <li class="list-group-item" [@animatedUpdate]="train.x">
          <h5>
            {{'Location (WGS-84)' | translate}}
          </h5>
          <p>
            {{'N' |translate}} {{train.x | qmRound : 5}}
            <br/>
            {{'E' |translate}} {{train.y | qmRound : 5}}
          </p>
        </li>
      </ul>
      <ng-template #konegisElseBlock>
        {{'GPS data is not available for this train.' | translate}}
      </ng-template>
    </div>
    <div class="card">
      <div class="card-header">
        {{'Data from Liikennevirasto' | translate}}
      </div>
      <ul *ngIf="trainSchedule; else trainScheduleElseBlock" class="list-group list-group-flush">
        <li class="list-group-item">
          <h5>
            {{'Ready for departure' | translate}}
          </h5>
          <p>
            {{trainSchedule.ready ? ('Yes' | translate) : ('No' | translate)}}
          </p>
        </li>
        <li class="list-group-item">
          <h5>
            {{'On motion' | translate}}
          </h5>
          <p>
            {{trainSchedule.state === 'RUNNING' ? ('Yes' | translate) : ('No' | translate)}}
          </p>
        </li>
        <li class="list-group-item">
          <h5>
            {{'Latest cause code' | translate}}
          </h5>
          <p>
            {{trainSchedule.causeString ? trainSchedule.causeString : 'Reason code is not available.' | translate}}
          </p>
        </li>
        <li class="list-group-item">
          <h5>
            {{'Cancelled' | translate}}
          </h5>
          <p>
            {{trainSchedule.state === 'CANCELLED' ? ('Yes' | translate) : ('No' | translate)}}
          </p>
        </li>
        <li class="list-group-item" [@animatedUpdate]="trainTracking?.trackSection">
          <h5>
            {{'Last reserved track section' | translate}}
          </h5>
          <p>
            <a class="link" (click)="zoomToTrackSection()">{{getLastTrainSection()}}</a>
          </p>
        </li>
      </ul>
      <ng-template #trainScheduleElseBlock>
        {{'LiVi Digitraffic data is not available for this train.' | translate}}
      </ng-template>
    </div>
  </div>
</div>
